import { createColumnHelper } from "@tanstack/react-table";

import type { Material } from "@/types";
import { Badge } from "@/ui/Badge";

const columnHelper = createColumnHelper<Material>();

export function getMaterialsTableColumns() {
  const columns = [
    columnHelper.accessor("name", {
      header: "Material Name",
      cell: (info) => (
        <span title={info.getValue()} className="block max-w-64 truncate">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("type", {
      header: "Type",
      cell: (info) => {
        const type = info.getValue();
        return (
          <Badge
            text={type === "pdf" ? "PDF" : "Video"}
            className={
              type === "pdf"
                ? "bg-tertiary-100 text-tertiary-800"
                : "bg-success-100 text-success-800"
            }
          />
        );
      },
    }),
    columnHelper.display({
      id: "published",
      header: "Status",
      cell: (info) => {
        const published = info.row.original.published;
        return (
          <Badge
            text={published ? "Published" : "Unpublished"}
            className={
              published
                ? "bg-primary-800 text-primary-50"
                : "bg-neutral-300 text-neutral-950"
            }
          />
        );
      },
    }),
  ];

  return columns;
}
